/* eslint-disable @typescript-eslint/naming-convention */
import { useSignal } from "@preact/signals-react"
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'

import Icon from './Icon.jsx'

function SortableItem({ col, onToggle }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: col.key })
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    }
    return (
        <div ref={setNodeRef} style={style} className="d-flex align-items-center px-2 py-1">
            <span
                {...attributes}
                {...listeners}
                style={{ cursor: 'grab', color: '#aaa', marginRight: 6, lineHeight: 1, touchAction: 'none' }}
            >
                <Icon icon="grip-vertical" width={14} height={14} />
            </span>
            <Form.Check
                id={`col-toggle-${col.key}`}
                label={col.title}
                checked={col.visible}
                onChange={() => onToggle(col.key)}
            />
        </div>
    )
}

export default function ColumnSelector({ columns, onChange, onReset }) {
    const showSignal = useSignal(false)

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
    )

    const handleDragEnd = ({ active, over }) => {
        if (over && active.id !== over.id) {
            const oldIndex = columns.findIndex(c => c.key === active.id)
            const newIndex = columns.findIndex(c => c.key === over.id)
            onChange(arrayMove(columns, oldIndex, newIndex))
        }
    }

    const handleToggle = (key) => {
        onChange(columns.map(c => c.key === key ? { ...c, visible: !c.visible } : c))
    }

    return (
        <Dropdown show={showSignal.value} onToggle={(v) => showSignal.value = v} autoClose="outside">
            <Dropdown.Toggle size="sm" variant="outline-secondary">
                Columns
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ maxHeight: 400, overflowY: 'auto', minWidth: 220 }}>
                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                    <SortableContext items={columns.map(c => c.key)} strategy={verticalListSortingStrategy}>
                        {columns.map(col => (
                            <SortableItem key={col.key} col={col} onToggle={handleToggle} />
                        ))}
                    </SortableContext>
                </DndContext>
                <Dropdown.Divider />
                <div className="px-2">
                    <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-decoration-none"
                        onClick={() => { onReset(); showSignal.value = false }}
                    >
                        Reset to defaults
                    </Button>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}
